<script lang="ts">
	import { BaseHeadTags } from '@shared/svelte-kit';
	import { page } from '$app/stores';
	import { getHeadTagsViewModel } from './head-tags-view-model';

	const viewModel = getHeadTagsViewModel();
	const { metadata } = viewModel;
</script>

<BaseHeadTags
	data={$metadata}
	baseURL={$page.url.host}
	path={$page.url.pathname} />
